import platform from "./platform";
import permissions from "./permissions.ts";
import {
    COMPANY_NAME,
    PRODUCT_NAME
} from "./product.ts";

export const config = {
    appTitle: PRODUCT_NAME,
    appSubTitle: PRODUCT_NAME,
    company: COMPANY_NAME,
    appLogoUrl: 'https://s3.amazonaws.com/cdn.flexi.network/flexi.network/images/logo/logo.png',
    platform: platform,
    permissions
}

export default config;
